import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../commonDesign/SydModal'
import Loading from '../../../molecules/Loading'
import { useGetDelegatedIdentity } from '../../../../api/delegatedIdentities'
import DelegatedIdentityForm from './DelegatedIdentityForm'

const DelegatedIdentityDialog = React.forwardRef(function DelegatedIdentityDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, identityId: null })

  const isEdit = !!dialogState.identityId
  const { data: existing, isLoading: isLoadingExisting } = useGetDelegatedIdentity(
    isEdit ? Number(dialogState.identityId) : null
  )

  const close = useCallback(() => {
    setDialogState({ open: false, identityId: null })
  }, [])

  const handleComplete = useCallback(() => {
    close()
    onComplete?.()
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (identityId = null) => {
      setDialogState({ open: true, identityId })
    }
  }), [])

  const formReady = !isEdit || (isEdit && !isLoadingExisting && !!existing)

  return (
    <SydModal
      open={dialogState.open}
      onClose={close}
      title={isEdit ? 'Edit Delegated Identity' : 'Create Delegated Identity'}
      size='medium'
    >
      <div>
        {dialogState.open && formReady ? (
          <DelegatedIdentityForm
            identityId={dialogState.identityId}
            existing={isEdit ? existing : null}
            onCancel={close}
            onComplete={handleComplete}
          />
        ) : dialogState.open ? (
          <Loading />
        ) : null}
      </div>
    </SydModal>
  )
})

DelegatedIdentityDialog.propTypes = {
  onComplete: PropTypes.func
}

export default DelegatedIdentityDialog
